module.exports = __webpack_public_path__ + "static/media/rt-bus-route-6.ade469a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/markers/rt-bus-route-6.svg
// module id = 297
// module chunks = 0